export default __webpack_public_path__ + "static/media/homepageImage1.215edecb.jpeg";